(function () {
  const configs = window.AscendGloboConfigs || {};
  const handle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  const config = handle ? configs[handle] : null;

  if (!config) return;

  const visualAssets = {
    clearCedar:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INPRODSPEC/1OOEOPDAS5FAR800/clear-red-cedar.jpg',
    knottyCedar:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INPRODSPEC/JRRTLH1BS5FAR800/Knotty-Red-Cedar.jpg',
    timberGlow:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/120224_56FBGC689IAT9N31/120224_1.jpg',
    narviKaamos:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKAAM_1UGTV6SLAIAT9N31/_12.jpg',
    apexMini:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APMI240_1VNL30UJ3KAT9N31/apex-mini_1.jpg',
    harviaKip:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HARVKIP_5N7K4M06SJAT9N31/HARKIPN_1.jpg',
    revive:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REV240_86VT8K7M9JAT9N31/_10.jpg',
    apex:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/APEX240_RPDQIMDR7JAT9N31/_12.jpg',
    narviKuru:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARKURU_FCDK6V0A8IAT9N31/_14.jpg',
    huumDrop:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMDROP_GK7EK1L18IAT9N31/_10.jpg',
    narviNc:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NARVINC_JBAU2N9O6IAT9N31/_10.jpg',
    reviveSlim:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/REVSLI_N8SENROJBJAT9N31/_14.jpg',
    huumHive:
      'https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HUUMHIVE_TDO260CF8IAT9N31/HUUMHIVE_1.jpg'
  };

  const optionSelector = (id) =>
    `.gpo-element[data-element-id="${CSS.escape(id)}"]`;

  const selectedValue = (root, id) => {
    const option = root.querySelector(optionSelector(id));
    if (!option) return '';

    const checked = option.querySelector('input:checked');
    if (checked) return checked.value;

    const select = option.querySelector('select');
    return select ? select.value : '';
  };

  const conditionMatches = (root, condition) => {
    if (!condition || !Array.isArray(condition.whens) || !condition.whens.length) {
      return true;
    }

    const results = condition.whens.map((rule) => {
      const actual = selectedValue(root, rule.select);
      return rule.where === 'NOT_EQUALS'
        ? actual !== rule.value
        : actual === rule.value;
    });

    return condition.match === 'any'
      ? results.some(Boolean)
      : results.every(Boolean);
  };

  const optionLabel = (element) =>
    element.querySelector('.label-content')?.textContent?.trim() || '';

  const selectedHeaterMode = (root) => {
    const heaterMode = Array.from(root.querySelectorAll('.gpo-element')).find(
      (element) => /^heater options?(?:\s*-.*)?$/i.test(optionLabel(element))
    );

    return heaterMode ? selectedValues(heaterMode)[0] || '' : '';
  };

  const supplementalConditionMatches = (root, element) => {
    const label = optionLabel(element);
    if (!/chimney|floor plate/i.test(label)) return true;

    return selectedHeaterMode(root) === 'Wood Heater';
  };

  const setOptionVisibility = (element, visible, required) => {
    const controls = Array.from(element.querySelectorAll('input, select, textarea'));
    const wasVisible = !element.hidden;

    element.hidden = !visible;
    element.style.display = visible ? '' : 'none';
    element.setAttribute('aria-hidden', visible ? 'false' : 'true');

    controls.forEach((control, index) => {
      control.disabled = !visible;
      control.required = Boolean(visible && required && index === 0);

      if (!visible && wasVisible) {
        if (control.matches('input[type="radio"], input[type="checkbox"]')) {
          control.checked = false;
        } else if (control.matches('select')) {
          control.selectedIndex = 0;
        } else {
          control.value = '';
        }
      }
    });
  };

  const noOptionVisual = (label, value) => {
    const text = value === 'None' ? `No ${label}` : value;
    const safeText = text.replace(/[<>&"']/g, '').slice(0, 24);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="220" height="168" viewBox="0 0 220 168">
      <rect width="220" height="168" fill="#f3efe7"/>
      <path d="M55 96h110M68 96V68h84v28M78 68V54h64v14" fill="none" stroke="#5f5a51" stroke-width="6" stroke-linecap="round"/>
      <path d="M51 43l118 82" stroke="#9a6b35" stroke-width="8" stroke-linecap="round"/>
      <text x="110" y="148" text-anchor="middle" font-family="Arial, sans-serif" font-size="16" fill="#27231e">${safeText}</text>
    </svg>`;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  };

  const visualForValue = (element, input, images) => {
    const value = input.value.trim();
    const label = element.querySelector('.label-content')?.textContent?.trim() || '';
    const context = `${element.dataset.elementId || ''} ${label} ${value}`.toLowerCase();

    if (value.startsWith('Clear Red Cedar')) return visualAssets.clearCedar;
    if (value.startsWith('Knotty Red Cedar')) return visualAssets.knottyCedar;
    if (images?.[value]) return images[value];

    if (context.includes('revive slim')) return visualAssets.reviveSlim;
    if (context.includes('revive')) return visualAssets.revive;
    if (context.includes('apex mini')) return visualAssets.apexMini;
    if (context.includes('apex')) return visualAssets.apex;
    if (context.includes('harvia') || context.includes('kip')) return visualAssets.harviaKip;
    if (context.includes('huum') && context.includes('drop')) return visualAssets.huumDrop;
    if (context.includes('huum') && context.includes('hive')) return visualAssets.huumHive;
    if (context.includes('narvi') && context.includes('kuru')) return visualAssets.narviKuru;
    if (context.includes('narvi') && context.includes('kaamos')) return visualAssets.narviKaamos;
    if (context.includes('narvi') && context.includes('nc')) return visualAssets.narviNc;
    if (context.includes('timberglow')) return visualAssets.timberGlow;
    if (value === 'None' || /^no\b/i.test(value)) return noOptionVisual(label, value);

    return '';
  };

  const applyImages = (element, images) => {
    let hasVisual = false;

    element.querySelectorAll('input').forEach((input) => {
      const url = visualForValue(element, input, images);
      if (!url || !input.id) return;

      const label = element.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!label) return;

      let image = label.querySelector('img.swatch-image');
      if (!image) {
        const inner = document.createElement('span');
        inner.className = 'gpo-swatch__inner ascend-option-visual';
        image = document.createElement('img');
        image.className = 'swatch-image';
        image.loading = 'lazy';
        inner.appendChild(image);
        label.prepend(inner);
      }

      if (image.getAttribute('src') !== url) {
        image.setAttribute('src', url);
      }
      image.alt = input.value;
      hasVisual = true;
    });

    element.classList.toggle('ascend-visual-options', hasVisual);
  };

  const selectedValues = (element) => {
    const checked = Array.from(
      element.querySelectorAll('input:checked:not(:disabled)')
    ).map((input) => input.value);
    if (checked.length) return checked;

    const select = element.querySelector('select:not(:disabled)');
    return select ? [select.value] : [];
  };

  const hasMeaningfulSelection = (element) =>
    selectedValues(element).some((value) => {
      const clean = String(value || '').trim();
      return clean && !/^--\s*select\s*--$/i.test(clean);
    });

  const visibleOptions = (root) =>
    Array.from(root.querySelectorAll('.gpo-element')).filter(
      (element) =>
        !element.hidden &&
        element.style.display !== 'none' &&
        element.getAttribute('aria-hidden') !== 'true'
    );

  const setOptionOpen = (element, open) => {
    element.classList.toggle('ascend-option-open', open);
  };

  const renderSelectionSummary = (element) => {
    const label = element.querySelector('.gpo-label');
    if (!label) return;

    let summary = label.querySelector('.ascend-selected-summary');
    const values = selectedValues(element)
      .map((value) => String(value || '').trim())
      .filter(Boolean);

    if (!values.length) {
      if (summary) summary.remove();
      return;
    }

    if (!summary) {
      summary = document.createElement('span');
      summary.className = 'ascend-selected-summary';
      label.appendChild(summary);
    }
    summary.textContent = values.join(', ');
  };

  const updateAccordionState = (root, changedElement, shouldAdvance) => {
    const options = visibleOptions(root);
    if (!options.length) return;

    options.forEach((element) => {
      const complete = hasMeaningfulSelection(element);
      element.classList.toggle('ascend-option-complete', complete);
      renderSelectionSummary(element);
    });

    const existingCurrent = options.find((element) =>
      element.classList.contains('ascend-option-current')
    );
    const changedIndex = changedElement ? options.indexOf(changedElement) : -1;
    const nextAfterChange =
      changedIndex >= 0
        ? options.slice(changedIndex + 1).find((element) => !hasMeaningfulSelection(element)) ||
          options[changedIndex + 1] ||
          changedElement
        : null;

    const target =
      shouldAdvance && nextAfterChange
        ? nextAfterChange
        : existingCurrent ||
          options.find((element) => !hasMeaningfulSelection(element)) ||
          options[0];

    options.forEach((element) => {
      const isTarget = element === target;
      element.classList.toggle('ascend-option-current', isTarget);
      setOptionOpen(element, isTarget);
    });

    if (shouldAdvance && target && target !== changedElement) {
      window.setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    }
  };

  const ensureBaseSelection = (root) => {
    const baseConfiguration = Array.from(
      root.querySelectorAll('.gpo-element')
    ).find((element) => /^base configuration$/i.test(optionLabel(element)));

    if (!baseConfiguration || baseConfiguration.querySelector('input:checked')) {
      return;
    }

    const firstChoice = baseConfiguration.querySelector(
      'input[type="radio"]:not(:disabled)'
    );
    if (firstChoice) firstChoice.checked = true;
  };

  const updateConfiguredTotal = (root) => {
    const summaries = Array.from(document.querySelectorAll('[data-ascend-builder-total]'));
    if (!summaries.length) return;

    const summary = summaries[0];
    const baseCents = Number(summary.dataset.baseCents || 0);
    let addonCents = 0;

    Object.entries(config.options).forEach(([id, definition]) => {
      const element = root.querySelector(optionSelector(id));
      if (
        !element ||
        !definition.prices ||
        !conditionMatches(root, definition.condition) ||
        !supplementalConditionMatches(root, element)
      ) {
        return;
      }

      selectedValues(element).forEach((value) => {
        addonCents += Math.round(Number(definition.prices[value] || 0) * 100);
      });
    });

    const formatter = new Intl.NumberFormat(
      document.documentElement.lang || 'en-CA',
      {
        style: 'currency',
        currency: summary.dataset.currency || 'CAD'
      }
    );
    const formatted = formatter.format((baseCents + addonCents) / 100);

    summaries.forEach((totalSummary) => {
      const value = totalSummary.querySelector('[data-ascend-builder-total-value]');
      if (value) value.textContent = formatted;
    });
    const productPrice = document.querySelector('[data-ascend-product-price]');
    if (productPrice) productPrice.textContent = formatted;
  };

  const refresh = (root, changedElement, shouldAdvance = false) => {
    ensureBaseSelection(root);

    Object.entries(config.options).forEach(([id, definition]) => {
      const element = root.querySelector(optionSelector(id));
      if (!element) return;

      const label = optionLabel(element);
      if (id.includes('stain') || label.toLowerCase().includes('stain')) {
        setOptionVisibility(element, false, false);
        return;
      }

      const visible =
        conditionMatches(root, definition.condition) &&
        supplementalConditionMatches(root, element);
      setOptionVisibility(element, visible, definition.required);
      if (visible) applyImages(element, definition.images);
    });
    updateConfiguredTotal(root);
    updateAccordionState(root, changedElement, shouldAdvance);
  };

  const initialize = (root) => {
    if (root.dataset.ascendConfiguratorReady === 'true') return;
    root.dataset.ascendConfiguratorReady = 'true';

    root.addEventListener('click', (event) => {
      const label = event.target.closest('.gpo-label');
      const element = label?.closest('.gpo-element');
      if (!element || element.hidden || element.style.display === 'none') return;

      const willOpen = !element.classList.contains('ascend-option-open');
      visibleOptions(root).forEach((option) => {
        option.classList.toggle('ascend-option-current', option === element);
        setOptionOpen(option, option === element ? willOpen : false);
      });
    });

    root.addEventListener('change', (event) => {
      const changedElement = event.target.closest('.gpo-element');
      refresh(root, changedElement, true);
      window.setTimeout(() => refresh(root), 0);
    });

    refresh(root);
  };

  const discover = () => {
    document.querySelectorAll('.gpo-app').forEach(initialize);
  };

  const start = () => {
    const root = document.documentElement;
    if (!root) return;

    let refreshQueued = false;
    const observer = new MutationObserver(() => {
      discover();
      if (refreshQueued) return;

      refreshQueued = true;
      window.setTimeout(() => {
        refreshQueued = false;
        document.querySelectorAll('.gpo-app').forEach((app) => refresh(app));
      }, 0);
    });
    observer.observe(root, { childList: true, subtree: true });
    discover();
  };

  if (document.documentElement) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
